import { CDParser } from "./CDParser";
import { CDElement } from "./CDElement";
import { CSSRuleContainer } from "./CSSRuleContainer";
import { CDProperty } from "./CDProperty";
import { CDKeyFrames } from "./CDKeyFrames";
import { CDSelector } from "./CDSelector";
import { CDMediaQuery } from "./CDMediaQuery";

export class CSSCreator 
{
  static appendCSS( css:any, replacementNode?:Element ) 
  {
    if ( typeof css !== "string" ) 
    {
      css = CSSCreator.create( css );
    }

    let styleElement = document.createElement( "style" );
    styleElement.type = "text/css";

    if ( ( styleElement as any ).styleSheet ) 
    {
      ( styleElement as any ).styleSheet.cssText = css;
    }
    else 
    {
      styleElement.appendChild( document.createTextNode( css ) );
    }

    if ( replacementNode !== null && replacementNode !== undefined ) 
    {
      replacementNode.parentNode.replaceChild( styleElement, replacementNode );
    }
    else 
    {
      document.querySelector( "head" ).appendChild( styleElement );
    }

    return styleElement;
  }

  static create( css:any ) 
  {
    let parser = new CDParser( css );
    let root = parser.root;
    
    let selectorMap = new Map<CDSelector,CSSRuleContainer>();

    let properties = root.$$( CDElement.CDPropertyType ) as CDProperty[];
    properties = properties.filter( p => ! p.isKeyFrameProperty );

    for ( let property of properties ) 
    {
      let selector = property.parentSelector as CDSelector;
      let ruleContainer = selectorMap.get( selector );

      if ( ! ruleContainer ) 
      {
        ruleContainer = new CSSRuleContainer();
        ruleContainer.selector = selector ;
        selectorMap.set( selector, ruleContainer );
      }

      ruleContainer.properties.push( property );
    }

    let mediaQueryMap = new Map<CDMediaQuery,CSSRuleContainer[]>();
    
    selectorMap.forEach(
      ( c, s ) =>
      {
        if ( ! s ) 
        {
          console.log( "Container has no selector: ", c ); 
          return; 
        }

        let mediaQuery = s.mediaQuery;
        
        if ( ! mediaQueryMap.has( mediaQuery ) )
        {
          mediaQueryMap.set( mediaQuery, [] );
        } 

        mediaQueryMap.get( mediaQuery ).push( c );
       
      }
    );

    let output:string[] = [];

    mediaQueryMap.forEach(
      ( containers, mediaQuery ) => 
      {
        if ( mediaQuery )
        {
          output.push( "@media " + mediaQuery.query + " {");
        }

        containers.forEach( container => ( output.push( container.getRule() ) ) );

        if ( mediaQuery )
        { 
          output.push( "}");
        }

      }
    )
    //selectorMap.forEach( container => ( output.push( container.getRule() ) ) );

    let keyFrameDefinitions = root.$$( CDElement.CDKeyFramesType ) as CDKeyFrames[];

    keyFrameDefinitions.forEach( k => output.push( k.getDefinition() ) ); 

    return output.join( "\n" );
  }
}